// @flow
export const CHOOSE_ORCHESTRATION_NAME: 'CHOOSE_ORCHESTRATION_NAME' =
  'CHOOSE_ORCHESTRATION_NAME';
export const CHOOSE_APP_GROUP: 'CHOOSE_APP_GROUP' = 'CHOOSE_APP_GROUP';
export const CHOOSE_ENTRY_EVENT: 'CHOOSE_ENTRY_EVENT' = 'CHOOSE_ENTRY_EVENT';



// WEBPACK FOOTER //
// ./src/constants/WipActionTypes.js